export const STOCKS_ROUTE_PREFIX = '/stocks';
export const STOCK_INSTRUMENT_ROUTE_PREFIX = `${STOCKS_ROUTE_PREFIX}/s`;
export const STOCK_POSITIONS_ROUTE = `${STOCKS_ROUTE_PREFIX}/positions`;
export const STOCK_ALLOCATIONS_ROUTE = `${STOCKS_ROUTE_PREFIX}/allocations`;
export const STOCK_TRANSACTIONS_ROUTE = `${STOCKS_ROUTE_PREFIX}/transactions`;
export const STOCK_IMPORTS_ROUTE = `${STOCKS_ROUTE_PREFIX}/imports`;
export const STOCK_IMPORTS_REVIEW_ROUTE_PREFIX = `${STOCK_IMPORTS_ROUTE}/review`;
export const STOCK_IMPORTS_RESULT_ROUTE_PREFIX = `${STOCK_IMPORTS_ROUTE}/result`;

export const IMPORTS_ROUTE = '/imports';
export const IMPORTS_REVIEW_ROUTE_PREFIX = `${IMPORTS_ROUTE}/review`;
export const IMPORTS_RESULT_ROUTE_PREFIX = `${IMPORTS_ROUTE}/result`;

export const isStocksRoute = (pathname = '') => (
  pathname === STOCKS_ROUTE_PREFIX
  || pathname.startsWith(`${STOCKS_ROUTE_PREFIX}/`)
);

export const stockRoutePath = (stockOrIdentifier) => {
  const identifier = typeof stockOrIdentifier === 'string'
    ? stockOrIdentifier
    : stockOrIdentifier?.symbol || stockOrIdentifier?.id;

  return identifier
    ? `${STOCK_INSTRUMENT_ROUTE_PREFIX}/${encodeURIComponent(identifier)}`
    : STOCKS_ROUTE_PREFIX;
};

export const STOCK_NAV_ROUTES = [
  { path: STOCKS_ROUTE_PREFIX, label: 'Dashboard', icon: '📊' },
  { path: STOCK_POSITIONS_ROUTE, label: 'Positions', icon: '💼' },
  { path: STOCK_ALLOCATIONS_ROUTE, label: 'Allocation planner', icon: '📈' },
  { path: STOCK_TRANSACTIONS_ROUTE, label: 'Transactions', icon: '📝' },
  { path: STOCK_IMPORTS_ROUTE, label: 'Imports', icon: '⬆️' },
];

// Instrument pages count as Positions, the way crypto token pages do.
export const isStockNavRouteActive = (routePath, pathname = '') => {
  if (routePath === STOCK_POSITIONS_ROUTE) {
    return pathname === STOCK_POSITIONS_ROUTE || pathname.startsWith(`${STOCK_INSTRUMENT_ROUTE_PREFIX}/`);
  }
  if (routePath === STOCK_IMPORTS_ROUTE) {
    return pathname === STOCK_IMPORTS_ROUTE || pathname.startsWith(`${STOCK_IMPORTS_ROUTE}/`);
  }
  return pathname === routePath;
};
